export const DEFAULT_LOCALE = 'sv'

export function getStoredLocale() {
  return localStorage.getItem('lang') || DEFAULT_LOCALE
}

export function ensureStoredLocale() {
  const locale = getStoredLocale()

  if (!localStorage.getItem('lang')) localStorage.setItem('lang', locale)

  return locale
}

export function syncI18nLocale(i18n, locale = getStoredLocale()) {
  if (i18n) i18n.locale = locale

  return locale
}

export function getCurrentLocale(i18n) {
  return (i18n && i18n.locale) || getStoredLocale()
}

export function selectLocalizedField(i18n, swedishField, englishField) {
  return getCurrentLocale(i18n) === 'sv' ? swedishField : englishField
}
